import { ElementState } from "@creatomate/preview";

const calculateVideoDuration = (mediaElements: ElementState[]) => (
  mediaElements.reduce((acc, curr) => acc + curr.duration, 0)
);

export default calculateVideoDuration;
